import Image from "next/image";
import React from "react";
import searchNotFoundImage from "@/public/images/searchNotFound.svg";
import { useTranslate } from "@/components/base/providers/TranslateProv";

type Props = {};

const index = (props: Props) => {
  const { locale } = useTranslate();
  return (
    <div className="w-full p-5 rounded-xl flex-col justify-center items-center gap-11 inline-flex mb-8">
      <div className="relative">
        <Image
          src={searchNotFoundImage}
          alt="OrderEmpty"
          className="w-full h-full"
          width={200}
          height={165}
        />
      </div>
      <div className="flex-col justify-center items-center gap-[26px] flex">
        <div className="text-center text-[#222222] text-[28px] font-bold">
          {locale === "ar" ? "لا توجد نتائج مطابقة" : "No result found"}
        </div>
        <div className="text-center text-[#6c7278] ">
          {locale === "ar"
            ? "نعتذر، لا توجد نتائج مطابقة لبحثك. يرجى التحقق من كتابة البحث بشكل صحيح أو المحاولة بكلمات مختلفة"
            : "Sorry, there is no result matching your search. Please check your search query or try different keywords."}
        </div>
      </div>
    </div>
  );
};

export default index;
